module.exports = __webpack_public_path__ + "static/img/li1_6.425cc521.png";